const raisedEvents = {};

export function raiseEventOnce(eventName) {
  if (raisedEvents[eventName]) return;
  raisedEvents[eventName] = true;
  window.postMessage(eventName);
}
